import ContactDetailsComponent from "./ContactDetailsComponent.tsx";

export default function ContactStillNeedHelpComponent(props: { phone?: boolean, chat?: boolean, form?: boolean }) {
    return (
        <div className={'contact-sub'}>
            <hr className={'hide-on-large-devices'}/>
            <p className={'align-center'}>
                Hvis du stadig har brug for hjælp, kan du kontakte os her:
            </p>
            <ContactDetailsComponent phone={props.phone} chat={props.chat} form={props.form}/>
        </div>
    )
}
